// 'Jan 01, 2020', read off Date#toString so it follows the browser's local time zone
export const formatShortDate = (value: Date | string | number): string => {
  const parts = String(new Date(value)).split(' ');
  return `${parts[1]} ${parts[2]}, ${parts[3]}`;
};
